import {Component, Input} from "@angular/core";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {HighRadiusService} from "./high-radius.service";
import {toggleLoading} from "../misc/loading.decorator";
import {handleErrors} from "../misc/handle-errors.decorator";
import {CreditCheckLogModel} from "./high-radius.model";
import {Observable} from "rxjs";

@Component({
  templateUrl: "high-radius-log-dialog.template.pug",
  providers: [
    HighRadiusService,
  ],
})

export class HighRadiusLogDialogComponent extends DialogComponent<null, null> {
  loading = true;
  creditCheckLogs: CreditCheckLogModel[] = [];

  @Input() projectId: string;
  @Input() customerBpId: string;
  @Input() selector: string = "project";

  constructor(
    public dialogService: DialogService,
    private highRadiusService: HighRadiusService,
  ) {
    super(dialogService);
  }

  static showModal(dialogService: DialogService, data: any): Observable<null> {
    return dialogService.addDialog(HighRadiusLogDialogComponent, data, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  @toggleLoading()
  @handleErrors()
  async loadData() {
    switch (this.selector) {
      case "project":
        this.creditCheckLogs = await this.highRadiusService.getCreditCheckLogs(this.projectId, "", 0);
        break;
      case "customer":
        this.creditCheckLogs = await this.highRadiusService.getCreditCheckLogs("", this.customerBpId, 0);
        break;
      default:
    }
  }

  async ready() {
    await this.loadData();
  }
}
